import React, { useEffect, useState } from "react";
import { getCurrencies, getCrypto } from "../lib/api";

export default function TickerStrip() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    let mounted = true;
    const load = async () => {
      try {
        const [fx, cr] = await Promise.all([getCurrencies(), getCrypto()]);
        const fxItems = (fx.currencies || []).slice(0, 8).map((c) => ({
          key: `fx-${c.code}`,
          label: `${c.flag} USD/${c.code}`,
          value: c.rate_to_usd,
          change: c.change_pct,
          fmt: (v) => v.toFixed(c.code === "JPY" || c.code === "INR" ? 2 : 4),
        }));
        const cryptoItems = (cr.crypto || []).slice(0, 5).map((c) => ({
          key: `c-${c.id}`,
          label: c.symbol,
          value: c.price_usd,
          change: c.change_24h_pct,
          fmt: (v) => `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`,
        }));
        if (mounted) setItems([...fxItems, ...cryptoItems]);
      } catch (e) {
        console.warn("ticker fetch failed", e);
      }
    };
    load();
    const id = setInterval(load, 60000);
    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  if (items.length === 0) return null;

  const row = (
    <div className="flex items-center gap-10 px-6">
      {items.map((i) => (
        <div
          key={i.key}
          className="flex items-center gap-2.5 text-xs whitespace-nowrap"
          data-testid={`ticker-item-${i.key}`}
        >
          <span className="text-neutral-500 uppercase tracking-widest font-medium">{i.label}</span>
          <span className="font-mono text-white">{i.fmt(i.value)}</span>
          <span
            className={`font-mono ${
              (i.change ?? 0) >= 0 ? "text-gold-400" : "text-red-400"
            }`}
          >
            {(i.change ?? 0) >= 0 ? "+" : ""}
            {(i.change ?? 0).toFixed(2)}%
          </span>
        </div>
      ))}
    </div>
  );

  return (
    <div
      className="border-y border-white/5 bg-black/40 overflow-hidden py-2.5"
      data-testid="ticker-strip"
    >
      <div className="flex ticker-track w-max">
        {row}
        {row}
      </div>
    </div>
  );
}
